import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 8C16 8.55228 15.6642 9 15.25 9H0.75C0.335787 9 0 8.55228 0 8C0 7.44772 0.335787 7 0.75 7H15.25C15.6642 7 16 7.44772 16 8Z",
		fill: "#006ADC"
	})
});
const ForwardRef = forwardRef(SvgLine);
export default ForwardRef;
